module.exports = __webpack_public_path__ + "img/people_network.abc8e2c2.svg";